import React from 'react';
import { Table } from 'react-bootstrap';
import dayjs from "dayjs";

import HWLog from '../../HWLibrary/HWLog';
import { s360ConfigService } from '../../Services/S360Config';

function MessageA19(props) {

  const parseTableHeaderColumns = () => {
    try {
      return JSON.parse(props.entry.text).headers || []
    } catch (error) {
      HWLog.warn("Invalid Table Data for Custom Type A19:");
    }
    return []
  }
  const messageTimeClassName = () => {
    return "s360-message-time-received";
  };

  const messageTimeStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA13Time;
  };

  const parseTableRowsData = () => {
    try {
      return JSON.parse(props.entry.text).data || []
    } catch (error) {
      HWLog.warn("Invalid Table Data for Custom Type A19:");
    }
    return []
  }

  const messageBoxStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA19Box;
  }

  const tableHeaderColumns = parseTableHeaderColumns();
  const tableRows = parseTableRowsData();
  return (
    <div className="s360-message-cotainer-custom-a19-received">
      <div className="s360-message-box-custom-a19-received" style={messageBoxStyle()}>
        <Table striped bordered size="sm">
          <thead>
            {tableHeaderColumns.map((columnName, index) => <th key={index} style={{ textAlign: "center", whiteSpace: "nowrap", padding: "5px" }}>{columnName}</th>)}
          </thead>
          <tbody>
            {tableRows.map((row, rowIndex) =>
              <tr key={rowIndex}>
                {row.map((rowValue, index) => <td key={index} style={{ textAlign: "center" }}>{rowValue}</td>)}
              </tr>
            )}
          </tbody>
        </Table>
        {props.isLastEntry &&   props.sentTimestamp && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
          </div>
        )}
      </div>

    </div>
  );

}

export default MessageA19;
